module.exports = __webpack_public_path__ + "img/user.557b7e06.png";